import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';
import { RealTime } from '../intercity.models';

@Injectable()
export class IntercityActions {
    // static SET_CUSTOMER_PROFILE = '[Customer]: Set customer';
    // static CLEAR_CUSTOMER_PROFILE = '[Customer]: Clear customer';

    static IC_FETCH_RESULTS_REQUEST_START = '[Intercity]: IC_FETCH_RESULTS_REQUEST_START';
    static IC_FETCH_RESULTS_REQUEST_SUCCESS = '[Intercity]: IC_FETCH_RESULTS_REQUEST_SUCCESS';
    static IC_FETCH_RESULTS_REQUEST_ERROR = '[Intercity]: IC_FETCH_RESULTS_REQUEST_ERROR';
    static IC_FETCH_RESULTS_REQUEST_COMPLETE = '[Intercity]: IC_FETCH_RESULTS_REQUEST_COMPLETE';

    static IC_FETCH_SEARCH_RESULTS_SUCCESS = '[Intercity] Set Fetch Search Results Success';
    static IC_SET_SELECTED_MODE = '[Intercity] Set Selected Mode';
    static IC_SET_SELECTED_JOURNEY_ID = '[Intercity] Set Selected Journey Id';
    static IC_SET_GENERAL_MESSAGES = '[Intercity] Set General Messages';
    static IC_SET_TRIP_PRODUCTS = '[Intercity] Set Trip Products';
    static IC_SET_TRIP_LAYOUTS = '[Intercity] Set Trip Layouts';
    static IC_SET_TRIP_DETAILS = '[Intercity] Set Trip Details';

    static IC_ADD_TRIP_PRODUCT = '[Intercity] Add Trip Product';
    static IC_ADD_TRIP_PRODUCT_WITH_SEAT = '[Intercity] Add Trip Product With Seat';
    static IC_REMOVE_TRIP_PRODUCT = '[Intercity] Remove Trip Product';

    static IC_SET_SELECTED_SEAT = '[Intercity] Set Selected Seat';

    static IC_CHANGE_SELECTED_SEAT = '[Intercity] Change Selected Seat';

    static IC_SET_PAYLOADS_MEDIUM = '[Intercity] Set Payloads Medium';

    static IC_RESET_STATE = '[Intercity] Reset State';

    static IC_SET_JOURNEY_REALTIME = '[Intercity] IC_SET_JOURNEY_REALTIME';

    static IC_SET_FILTERED_DIRECT_JOURNEYS = '[Intercity] Set filtered direct journeys ids';
    static IC_SET_FILTERED_TRANSFER_JOURNEYS = '[Intercity] Set filtered transfer journeys ids';

    fetchSearchResultsSuccess(results): RidangoReduxAction {
        return {
            type: IntercityActions.IC_FETCH_SEARCH_RESULTS_SUCCESS,
            payload: results
        };
    }

    setSelectedMode(mode: string): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_SELECTED_MODE,
            payload: mode
        };
    }

    setSelectedJourneyId(journeyId: string): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_SELECTED_JOURNEY_ID,
            payload: journeyId
        };
    }

    setGeneralMessages(messages: any[]): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_GENERAL_MESSAGES,
            payload: messages
        };
    }
    setTripProducts(tripProducts: any): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_TRIP_PRODUCTS,
            payload: tripProducts
        };
    }
    setTripLayouts(tripLayouts: any): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_TRIP_LAYOUTS,
            payload: tripLayouts
        };
    }
    setTripDetails(tripDetails: any): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_TRIP_DETAILS,
            payload: tripDetails
        };
    }

    addTripProduct(
        tripId: any,
        productId: any,
        orderIndex: number,
        cartId: any = null,
        seatId: any = null,
        locationOrder: any = null
    ): RidangoReduxAction {
        if (seatId) {
            return {
                type: IntercityActions.IC_ADD_TRIP_PRODUCT_WITH_SEAT,
                payload: {
                    tripId: tripId,
                    productId: productId,
                    seatId: seatId,
                    cartId: cartId,
                    locationOrder: locationOrder,
                    orderIndex: orderIndex
                }
            };
        }
        return {
            type: IntercityActions.IC_ADD_TRIP_PRODUCT,
            payload: { tripId: tripId, productId: productId, cartId: cartId, orderIndex: orderIndex }
        };
    }

    removeTripProduct(tripId: any, productId: any): RidangoReduxAction {
        return {
            type: IntercityActions.IC_REMOVE_TRIP_PRODUCT,
            payload: { tripId: tripId, productId: productId }
        };
    }

    setSelectedSeat(trip, seat): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_SELECTED_SEAT,
            payload: { trip: trip, seat: seat }
        };
    }

    changeSelectedSeat(tripId, fromSeat, toSeat): RidangoReduxAction {
        return {
            type: IntercityActions.IC_CHANGE_SELECTED_SEAT,
            payload: {
                tripId: tripId,
                fromSeat: fromSeat,
                toSeat: toSeat
            }
        };
    }

    setPayloadsMedium(medium): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_PAYLOADS_MEDIUM,
            payload: medium
        };
    }

    resetState(): RidangoReduxAction {
        return {
            type: IntercityActions.IC_RESET_STATE
        };
    }

    setJourneyRealtime(journeyUid: string, realtime: RealTime): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_JOURNEY_REALTIME,
            payload: {
                journeyUid: journeyUid,
                realtime: realtime
            }
        };
    }

    setFilteredDirectJourneys(journeyIds: string[]): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_FILTERED_DIRECT_JOURNEYS,
            payload: journeyIds
        };
    }

    setFilteredTransferJourneys(journeyIds: string[]): RidangoReduxAction {
        return {
            type: IntercityActions.IC_SET_FILTERED_TRANSFER_JOURNEYS,
            payload: journeyIds
        };
    }
}
